module.exports = __webpack_public_path__ + "static/media/knife-kitchen.bcdf2583.svg";